import { ParsedUrlQuery } from 'querystring';

export const buildApplicationIdFromQuery = (routerQuery: ParsedUrlQuery) => {
  let applicationId = routerQuery?.application_id;
  applicationId = Array.isArray(applicationId)
    ? applicationId[0]
    : applicationId;

  applicationId =
    typeof applicationId === 'string' && applicationId?.trim()
      ? applicationId?.trim()
      : null;

  let redirectTo = routerQuery?.redirectTo;
  redirectTo = Array.isArray(redirectTo) ? redirectTo[0] : redirectTo;
  redirectTo =
    typeof redirectTo === 'string' && redirectTo?.trim()
      ? redirectTo?.trim()
      : null;

  if (!applicationId && redirectTo) {
    const applicationIdMatch = redirectTo?.match(
      /^\/?apps\/([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})(?:\/|$)/
    );
    applicationId = applicationIdMatch?.[1] || null;
  }

  return applicationId;
};
